import React, { useState } from 'react'
import { useGameStore } from '../store/gameStore'
import { battleAPI } from '../services/api'
import './GameHub.css'

function GameHub() {
  const { setCurrentPage, currentTeam, startBattle, setBattleState, user } = useGameStore()
  const [loading, setLoading] = useState(false)
  const [battleMode, setBattleMode] = useState<'pve' | 'pvp'>('pve')

  const handleStartBattle = async () => {
    if (!currentTeam) {
      alert('Please select a team first!')
      return
    }

    setLoading(true)
    try {
      const response = await battleAPI.startBattle(currentTeam.id, battleMode === 'pvp')
      setBattleState(response.data.battleState)
      startBattle()
      setCurrentPage('battle')
    } catch (error) {
      alert('Failed to start battle')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="game-hub">
      <div className="hub-header">
        <h2>⚔️ Battle Arena</h2>
      </div>

      <div className="hub-content">
        <div className="battle-modes">
          <div
            className={`mode-card ${battleMode === 'pve' ? 'active' : ''}`}
            onClick={() => setBattleMode('pve')}
          >
            <h3>🤖 PvE - Fight AI</h3>
            <p>Challenge computer opponents and earn rewards</p>
            <ul>
              <li>50-200 coins per win</li>
              <li>100 EXP per victory</li>
              <li>No player risk</li>
            </ul>
          </div>

          <div
            className={`mode-card ${battleMode === 'pvp' ? 'active' : ''}`}
            onClick={() => setBattleMode('pvp')}
          >
            <h3>⚔️ PvP - Fight Players</h3>
            <p>Battle against other players worldwide</p>
            <ul>
              <li>Higher rewards for victories</li>
              <li>Competitive rankings</li>
              <li>Real-time battles</li>
            </ul>
          </div>
        </div>

        <div className="start-battle-section">
          <h3>Selected Team: {currentTeam?.name || 'No team selected'}</h3>
          <button
            className="btn-start-battle"
            onClick={handleStartBattle}
            disabled={loading || !currentTeam}
          >
            {loading ? 'Starting Battle...' : 'Start Battle'}
          </button>
          <button
            className="btn-team-builder"
            onClick={() => setCurrentPage('team-builder')}
          >
            Select Team
          </button>
        </div>

        <div className="quick-draw">
          <h3>🎴 Quick Draw Cards</h3>
          <p>Draw cards to strengthen your deck</p>
          <button
            className="btn-primary"
            onClick={() => setCurrentPage('card-library')}
          >
            Go to Card Library
          </button>
        </div>
      </div>
    </div>
  )
}

export default GameHub
